import Api from '@/services/Api'

export default {
    // Obtener toda la trazabilidad
    getAllTrazabilidad() {
        return Api().get('trazabilidad')
    },

    // Obtener usuarios que aparecen en trazabilidad
    getUsuarios() {
        return Api().get('trazabilidad/usuarios')
    },

    // Obtener tablas registradas en trazabilidad
    getTablas() {
        return Api().get('trazabilidad/tablas')
    }
}